<template>
    <v-navigation-drawer
        id="app-drawer"
        v-model="inputValue"
        app
        dark
        floating
        persistent
        mobile-break-point="991"
        width="260"
    >
        <v-img :src="image" :gradient="sidebarOverlayGradiant" height="100%">
            <v-list dense>
                <v-list-item to="/">
                    <v-list-item-content>
                        <v-list-item-title class="title">
                            Carreras
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider />
                <!--<v-list-item v-if="responsive">
                    <v-text-field class="purple-input search-input" label="Search..." color="purple" />
                </v-list-item>-->

                <!---->
                <v-list-item to="/universidades" :active-class="color">
                    <v-list-item-icon>
                        <v-icon>mdi-school</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Universidades</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/areas" :active-class="color">
                    <v-list-item-icon>
                        <v-icon>mdi-school</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Área de carreras</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/solicitud_informaciones" :active-class="color">
                    <v-list-item-icon>
                        <v-icon>mdi-information</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Solicitudes Información</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/universidad_recomendadas" :active-class="color">
                    <v-list-item-icon>
                        <v-icon>mdi-book-variant</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Universidades Recomendadas</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/ponderables" :active-class="color">
                    <v-list-item-icon>
                        <v-icon>mdi-book-variant</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Ponderables</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <!-- <v-list-group>
                    <template v-slot:activator>
                        <v-list-item-title>Ejemplos del template</v-list-item-title>
                    </template>

                    <v-list-item v-for="(link, i) in links" :key="i" :to="link.to" :active-class="color">
                        <v-list-item-icon>
                            <v-icon>{{ link.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title v-text="link.text" />
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group> -->
                <!---->
            </v-list>
        </v-img>
    </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from "vuex"

export default {
    data: () => ({
        links: [
            {
                to: "/dashboard",
                icon: "mdi-view-dashboard",
                text: "Dashboard"
            },
            {
                to: "/user-profile",
                icon: "mdi-account",
                text: "User Profile"
            },
            {
                to: "/table-list",
                icon: "mdi-clipboard-outline",
                text: "Table List"
            },
            {
                to: "/typography",
                icon: "mdi-format-font",
                text: "Typography"
            },
            {
                to: "/icons",
                icon: "mdi-chart-bubble",
                text: "Icons"
            },
            {
                to: "/maps",
                icon: "mdi-map-marker",
                text: "Maps"
            },
            {
                to: "/notifications",
                icon: "mdi-bell",
                text: "Notifications"
            }
        ],
        responsive: false
    }),
    computed: {
        ...mapState("app", ["image", "color"]),
        inputValue: {
            get() {
                return this.$store.state.app.drawer
            },
            set(val) {
                this.setDrawer(val)
            }
        },
        items() {
            return this.$t("Layout.View.items")
        },
        sidebarOverlayGradiant() {
            return `${this.$store.state.app.sidebarBackgroundColor}, ${this.$store.state.app.sidebarBackgroundColor}`
        }
    },
    mounted() {
        this.onResponsiveInverted()
        window.addEventListener("resize", this.onResponsiveInverted)
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResponsiveInverted)
    },
    methods: {
        ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
        onResponsiveInverted() {
            if (window.innerWidth < 991) {
                this.responsive = true
            } else {
                this.responsive = false
            }
        }
    }
}
</script>

<style lang="scss">
#app-drawer {
    .v-list-item {
        border-radius: 4px;

        &--buy {
            margin-top: auto;
            margin-bottom: 17px;
        }
    }
    .v-list-item--active {
        color: white !important;
    }
    .v-list-item--link {
        color: inherit;
    }

    /*.v-image__image--contain {
        top: 9px;
        height: 60%;
    }*/

    .search-input {
        margin-bottom: 30px !important;
        padding-left: 15px;
        padding-right: 15px;
    }

    div.v-responsive.v-image > div.v-responsive__content {
        overflow-y: auto;
    }
}
</style>
